import { StarRating } from '../profile/customersurveyform';
import axios from 'axios';
import { useState, useEffect } from 'react'; // ADD useEffect import
import GoogleImportButton from './GoogleImportButton'; // Add this import

// Add this:
const reviewKey = (r, i) =>
  r?.customersurvey_id ??
  r?.customersurvey_token ??
  r?.review_id ??
  r?.id ??
  `${r?.source || 'local'}-${r?.created_at || r?.customersurvey_created_at || ''}-${i}`;

export default function AllReviewsList({
  reviews,
  showReplyStatus = false,
  hideControls = false,
  getUserColor,
  onReviewsImported,
  containerClassName,
  getRevieweeLabel,
}) { // Added onReviewsImported prop




        const [respondingTo, setRespondingTo] = useState(null); // token of the card being replied to
        const [responseText, setResponseText] = useState('');
        const [submittedToken, setSubmittedToken] = useState(null); // track just-submitted survey
        const [isSubmitting, setIsSubmitting] = useState(false);
        const [showImportButton, setShowImportButton] = useState(false); // ADD THIS LINE

        // ADD THIS useEffect BLOCK
        useEffect(() => {
          // Only show import button after a brief delay if still no reviews
          if (reviews.length === 0) {
            const timer = setTimeout(() => {
              setShowImportButton(true);
            }, 500); // 1 second delay
            
            return () => clearTimeout(timer);
          } else {
            setShowImportButton(false);
          }
        }, [reviews.length]);
        return (
    <div className="space-y-4 pr-2 pb-6">

      {/* Show import button ONLY when there are no reviews after delay */}
      {showImportButton && reviews.length === 0 ? (
        <>
          <div className="hover:bg-blue-50 transition-all duration-200 rounded-lg">
            <GoogleImportButton onReviewsImported={onReviewsImported} />
          </div>
          
          {/* Add space and alternative option */}
          <div className="mt-8"></div> {/* Space between sections */}
          
          <div 
            className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center cursor-pointer hover:border-[#00aef7] hover:bg-blue-50 transition-all duration-200"
            onClick={() => window.location.href = '/customers'}
          >
            <img 
              src="/images/ehandshake.png" 
              alt="eHandshake" 
              className="w-12 h-12 mx-auto mb-3"
            />
            <p className="text-sm text-gray-600 font-medium">
              or add your own customers and send them survey requests
            </p>
          </div>
        </>
      ) : (
        // Show existing reviews when there are any
        reviews.map((review, i) => (
        <div key={reviewKey(review, i)} className="border-b border-gray-100 pb-3">
          <div className="flex justify-between items-start">
            <div>
              <p className="font-medium text-sm">
                {review.customersurvey_google_origin === 'google_places' ? (
                  review.customersurvey_google_author?.trim()
                    ? (
                        review.customersurvey_google_author.trim().includes(' ')
                          ? (() => {
                              const parts = review.customersurvey_google_author.trim().split(' ');
                              return `${parts[0]} ${parts[1].charAt(0)}.`;
                            })()
                          : review.customersurvey_google_author.trim()
                      )
                    : 'Google Reviewer'
                ) : (
                  `${review.customer_firstname || ''} ${review.customer_lastname ? review.customer_lastname.charAt(0) + '.' : ''}`.trim() || 'Customer'
                )}
              </p>

              <p className="text-xs text-gray-400 mt-1">
                {(() => {
                  const dateStr = review.customersurvey_created_at || review.date;
                  const parsedDate = dateStr ? new Date(dateStr) : null;
                  return parsedDate && !isNaN(parsedDate)
                    ? parsedDate.toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                      })
                    : 'Unknown Date';
                })()}
              </p>
            </div>
            <div className="text-right">
                <p className="font-bold text-brand">
                {!isNaN(parseFloat(review.rating)) ? parseFloat(review.rating).toFixed(2) : 'N/A'}
                </p>
              <StarRating rating={review.rating} />
            </div>
          </div>
{/* Review text container */}
{(review.comments || review.customersurvey_google_origin === 'google_places') && (
  <div
    className="mt-2 rounded-lg"
    style={{
      borderLeft: `5px solid ${
        review?.customersurvey_google_origin
          ? '#9CA3AF20'
          : ((getUserColor && getUserColor(review?.user_id)) || '#CCCCCC') + '40'
      }`
    }}
  >
    <p className="text-xs text-gray-600 bg-gray-50 p-2 rounded min-h-[30px]">
      {review.comments ? `"${review.comments}"` : " "}
    </p>
  </div>
)}

{/* Google attribution row — icon + text, below the review */}
{review.customersurvey_google_origin === 'google_places' && (
  <div className="flex items-center gap-1 mt-1 justify-end">
    {review.customersurvey_google_attribution_url ? (
      <a
        href={review.customersurvey_google_attribution_url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 48 48">
          <path fill="#4285F4" d="M24 9.5c3.34 0 5.63 1.44 6.93 2.65l5.08-4.91C32.67 4.02 28.74 2 24 2 14.91 2 7.54 7.88 4.64 15.35l5.89 4.57C12.12 13.12 17.56 9.5 24 9.5z"/>
          <path fill="#34A853" d="M46.5 24c0-1.53-.14-2.99-.4-4.4H24v8.33h12.7c-.55 3.02-2.19 5.58-4.7 7.31l7.38 5.71C43.98 36.9 46.5 30.97 46.5 24z"/>
          <path fill="#FBBC05" d="M10.53 28.74a14.4 14.4 0 0 1 0-9.47l-5.89-4.57a23.953 23.953 0 0 0 0 18.61l5.89-4.57z"/>
          <path fill="#EA4335" d="M24 46c6.48 0 11.91-2.15 15.88-5.86l-7.38-5.71c-2.04 1.37-4.65 2.19-8.5 2.19-6.44 0-11.88-3.62-14.46-8.77l-5.89 4.57C7.54 40.12 14.91 46 24 46z"/>
        </svg>
        <span className="text-[10px] text-gray-400">Review from Google</span>
      </a>
    ) : (
      <>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 48 48">
          <path fill="#4285F4" d="M24 9.5c3.34 0 5.63 1.44 6.93 2.65l5.08-4.91C32.67 4.02 28.74 2 24 2 14.91 2 7.54 7.88 4.64 15.35l5.89 4.57C12.12 13.12 17.56 9.5 24 9.5z"/>
          <path fill="#34A853" d="M46.5 24c0-1.53-.14-2.99-.4-4.4H24v8.33h12.7c-.55 3.02-2.19 5.58-4.7 7.31l7.38 5.71C43.98 36.9 46.5 30.97 46.5 24z"/>
          <path fill="#FBBC05" d="M10.53 28.74a14.4 14.4 0 0 1 0-9.47l-5.89-4.57a23.953 23.953 0 0 0 0 18.61l5.89-4.57z"/>
          <path fill="#EA4335" d="M24 46c6.48 0 11.91-2.15 15.88-5.86l-7.38-5.71c-2.04 1.37-4.65 2.19-8.5 2.19-6.44 0-11.88-3.62-14.46-8.77l-5.89 4.57C7.54 40.12 14.91 46 24 46z"/>
        </svg>
        <span className="text-[10px] text-gray-400">Review from Google</span>
      </>
    )}
  </div>
)}

            {typeof getRevieweeLabel === 'function' && (
              <div className="mt-1 text-[10px] leading-tight text-gray-400 text-left">
                {(() => {
                  const label = getRevieweeLabel(review);
                  return label ? String(label) : '';
                })()}
              </div>
            )}


            {showReplyStatus && (

            <>
                  {review.customersurvey_user_reply ? (
                    <p className="text-xs italic mt-2 text-blue-400 px-2">
                      "{review.customersurvey_user_reply}"
                    </p>
                  ) : (
                <>
                    {respondingTo === review.customersurvey_token ? (
                    <div className="mt-2">
                        <textarea
                          value={responseText}
                          onChange={(e) => !isSubmitting && setResponseText(e.target.value)}
                          className={`w-full border h-[100px] border-gray-300 rounded px-2 py-1 text-xs focus:ring-1 focus:ring-blue-500 focus:border-blue-500 ${
                            isSubmitting ? 'bg-gray-50 cursor-not-allowed opacity-75' : ''
                          }`}
                          rows={2}
                          placeholder={isSubmitting ? 'Submitting...' : 'Write your response...'}
                          readOnly={isSubmitting}
                        />
                        <div className="flex justify-end gap-2 mt-1">
                        <button
                          onClick={async () => {
                            if (isSubmitting) return;
                            setIsSubmitting(true);
                            try {
                              const res = await axios.post('/api/profile/survey/respond', {
                                token: review.customersurvey_token,
                                responseText
                              }, { withCredentials: true });
                              setSubmittedToken(review.customersurvey_token);
                              review.customersurvey_user_reply = responseText;
                              setRespondingTo(null);
                            } catch (err) {
                              alert(err.response?.data?.error || 'Failed to submit response');
                            } finally {
                              setIsSubmitting(false);
                            }
                          }}
                          className="p-1 text-green-500 hover:text-green-700 hover:bg-green-100 rounded"
                        >
                          {isSubmitting ? (
                            <svg className="animate-spin h-5 w-5 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                            </svg>
                          )}
                        </button>
                        {!isSubmitting && (
                          <button
                            onClick={() => {
                              setRespondingTo(null);
                              setResponseText('');
                            }}
                            className="p-1 text-red-500 hover:text-red-700 hover:bg-red-100 rounded"
                            title="Cancel"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          </button>
                        )}
                    </div>

                    </div>
                    ) : (
                    <>
                      {!isSubmitting && !hideControls && (
                        <span
                          onClick={() => setRespondingTo(review.customersurvey_token)}
                          className="text-[10px] text-red-600/50 font-medium cursor-pointer hover:text-red-600/70"
                        >
                          Not Replied
                        </span>
                      )}

                    </>
                    )}
                </>
                )}
            </>
            )}
        </div>
      ))
      )}
    </div>
  );
}